import { Check, Copy } from "@phosphor-icons/react";
import { useState } from "react";

import { Button } from "common/components/ui/Button";
import { Tag } from "common/components/ui/Tag";

export default function ApiKeyTag({ token }: { token: string }) {
  const [isCopied, setIsCopied] = useState(false);

  function onCopy() {
    navigator.clipboard.writeText(token).then(() => {
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, 1000);
    });
  }

  return (
    <div className="flex items-center gap-x-1">
      <Tag variant="tertiary">
        {`${token.slice(0, 6)}.......${token.slice(-2)}`}
      </Tag>
      <Button
        size="xs"
        intent="iconOnly"
        variant="ghost-black"
        onClick={onCopy}
        type="button"
      >
        {isCopied ? <Check /> : <Copy />}
      </Button>
    </div>
  );
}
